import styled from 'styled-components'

import { InputComponent as DefaultInputComponent } from '../../Shared'

export const InputComponent = styled(DefaultInputComponent)`
	text-align: center;
	font-size: 20px;
	height: 100%;
	width: 100%;
	padding-block: 0;
	padding-inline: 0;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none; /* stylelint-disable-line */
		margin: 0;
	}

	&[type="number"] {
		-moz-appearance: textfield; /* stylelint-disable-line */
	}
`
